import { useState } from "react";
import BlacklistRow from "./BlacklistRow";
import ReactPaginate from "react-paginate";

import styles from "./BlacklistTable.module.scss";

const BlacklistTable = ({
  entries,
  sortConfig,
  onSort,
  onEdit,
  onDelete,
  hasWriteAccess,
  loading,
  pagination,
  onPageChange
}) => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const handleSort = (field) => {
    if (onSort) {
      onSort(field);
    }
  };

  const getSortIcon = (field) => {
    if (sortConfig?.field !== field) return null;
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1; // ReactPaginate uses 0-based indexing
    onPageChange(selectedPage);
  };

  const showPagination = pagination && pagination.totalPages > 1;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={`${styles.row} ${hasWriteAccess ? styles.withActions : styles.withoutActions}`}>
            <div 
              className={styles.column}
              onClick={() => handleSort('blacklist_type')}
              style={{ cursor: 'pointer' }}
            >
              Type {getSortIcon('blacklist_type')}
            </div>
            <div 
              className={styles.column}
              onClick={() => handleSort('blacklist_display_name')}
              style={{ cursor: 'pointer' }}
            >
              Contact / Domain {getSortIcon('blacklist_display_name')}
            </div>
            <div className={styles.column}>
              Customer
            </div>
            <div 
              className={styles.column}
              onClick={() => handleSort('reason')}
              style={{ cursor: 'pointer' }}
            >
              Reason {getSortIcon('reason')}
            </div>
            <div 
              className={styles.column}
              onClick={() => handleSort('created_by_name')}
              style={{ cursor: 'pointer' }}
            >
              Added By {getSortIcon('created_by_name')}
            </div>
            <div 
              className={styles.column}
              onClick={() => handleSort('created_at')}
              style={{ cursor: 'pointer' }}
            >
              Added On {getSortIcon('created_at')}
            </div>
            {hasWriteAccess && (
              <div className={styles.column}>
                Actions
              </div>
            )}
          </div>
        </div>
        <div className={styles.body}>
          {entries.map((entry) => (
            <BlacklistRow
              key={entry.id}
              entry={entry}
              onEdit={onEdit}
              onDelete={onDelete}
              hasWriteAccess={hasWriteAccess}
              isHovered={hoveredRow === entry.id}
              onMouseEnter={() => setHoveredRow(entry.id)}
              onMouseLeave={() => setHoveredRow(null)}
            />
          ))}
        </div>
      </div>

      {loading && (
        <div className={styles.loading}>
          Loading...
        </div>
      )}

      {showPagination && (
        <div className={styles.paginationContainer}>
          <div className={styles.paginationInfo}>
            Showing {Math.min((pagination.page - 1) * pagination.pageSize + 1, pagination.total)} to {Math.min(pagination.page * pagination.pageSize, pagination.total)} of {pagination.total} entries
          </div>
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            pageCount={pagination.totalPages}
            onPageChange={handlePageClick}
            forcePage={pagination.page - 1} // ReactPaginate uses 0-based indexing
            containerClassName={styles.pagination}
            previousLinkClassName={styles.paginationLink}
            nextLinkClassName={styles.paginationLink}
            disabledClassName={styles.disabled}
            activeClassName={styles.active}
            pageClassName={styles.pageItem}
            pageLinkClassName={styles.pageLink}
            breakClassName={styles.break}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
          />
        </div>
      )}
    </div>
  );
};

export default BlacklistTable;